import { memo, type ComponentProps } from "react";
import Markdown, { defaultUrlTransform } from "react-markdown";
import remarkGfm from "remark-gfm";
import { markdownAssetHash } from "../documents/markdown-assets";
import { useAssetUrl } from "./useAssetUrl";

interface MarkdownPreviewProps {
  markdown: string;
  compact?: boolean;
}

export const MarkdownPreview = memo(function MarkdownPreview({ markdown, compact = true }: MarkdownPreviewProps) {
  return (
    <div className={`markdown-preview ${compact ? "markdown-preview--compact" : ""}`}>
      {markdown ? (
        <Markdown
          remarkPlugins={[remarkGfm]}
          components={{ img: MarkdownImage }}
          urlTransform={(value) => markdownAssetHash(value) ? value : defaultUrlTransform(value)}
        >
          {markdown}
        </Markdown>
      ) : <p className="markdown-preview__placeholder">写点什么…</p>}
    </div>
  );
});

function MarkdownImage({ src, alt, ...props }: ComponentProps<"img">) {
  const hash = markdownAssetHash(typeof src === "string" ? src : undefined);
  const localSource = useAssetUrl(hash);
  if (hash && !localSource) {
    return <span className="markdown-preview__image-loading" role="img" aria-label={alt || "正在加载图片"} />;
  }
  return (
    <img
      {...props}
      src={hash ? localSource : src}
      alt={alt ?? ""}
      loading="lazy"
      draggable={false}
    />
  );
}
